export default {
    init() {
        this.filterAddRow();
        this.displayButtons();
        this.initFilteringFilterSettingsSelects();
        this.initFilteringInnerFilterSettingsSelects();
        this.filteringClearAllFilters();
        // this.auctionFavorite();
        this.filterButton();
        this.gridResponsive();
    },


    filterAddRow(){
        let select2Options = {
            placeholder: 'Select',
            minimumResultsForSearch: -1
        };

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-row') && $(e.target).hasClass('new')) {
                let parent = $(e.target).closest('.add-row-wrap');
                let validation = true;
                parent.find('.input-wrap').removeClass('error');

                $(".input-wrap:not(.disabled) select.select2", parent).each(function () {
                    let element = $(this);
                    if (element.val() === "") {
                        validation = false;
                        element.closest('.input-wrap').addClass('error');
                    }
                });

                $(".input-wrap:not(.disabled) .form-input", parent).each(function () {
                    let element = $(this);
                    if (element.val() === "") {
                        validation = false;
                        element.closest('.input-wrap').addClass('error');
                    }
                });

                if (validation ==  true) {
                    $('.new-row select').select2('destroy');
                    parent.find('.input-wrap').removeClass('error');
                    $('.filter-divider').remove();
                    let clonedRow = parent.clone();
                    let clonedText = '<div class="filter-divider"><div class="text">Added</div></div>';
                    clonedRow.insertBefore(parent).attr('id', 'new' + getRandomInt(9, 99));
                    clonedRow.after(clonedText);
                    parent.parent().find('.add-row-wrap').eq(1).removeClass('new-row').find('.add-row.new').hide();
                    parent.parent().find('.add-row-wrap.new-row .select').val('');
                    parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete').addClass('show');
                    let newDeleteBtn = parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete');
                    deleteRow(newDeleteBtn);
                   $('.add-row-wrap select').select2();
                }
            }
        });

        function deleteRow(btn) {
            btn.on('click', function () {
                $(this).closest('.add-row-wrap').remove();
            });
        }

        function getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min) + min);
        }
    },


    displayButtons(){
        $('.display-inline-btn').on('click', function(){
            let loader = $('.loader-holder');
            loader.show();
            $('.product-card--wrap').addClass('inline');
            $('.display-data-type').removeClass('active');
            $(this).addClass('active');
            setTimeout(function () {
                loader.fadeOut(300);
            }, 1000);
        });

        $('.display-grid-btn').on('click', function(){
            let loader = $('.loader-holder');
            loader.show();
            $('.product-card--wrap').removeClass('inline');
            $('.display-data-type').removeClass('active');
            $(this).addClass('active');
            setTimeout(function () {
                loader.fadeOut(300);
            }, 1000);
        });
    },

    gridResponsive(){
        // function checkWindowWidth() {
        //     var windowWidth = window.innerWidth;  // Use window.innerWidth instead
        //     if (windowWidth < 768) {
        //         $('.product-card--wrap').removeClass('inline');
        //     } else {
        //         $('.product-card--wrap').addClass('inline');
        //     }
        // }
        //
        // checkWindowWidth();
        //
        // // Check on window resize
        // $(window).resize(function() {
        //     checkWindowWidth();
        // });
    },

    initFilteringInnerFilterSettingsSelects() {
        let filterContent = $('.auction-lots-filter--extra');
        filterContent.hide();
        $('.filter-btn').on('click',function(){
            if($(this).hasClass('active')){
                filterContent.slideToggle(300);
                $(this).removeClass('active');
            } else {
                $(this).addClass('active');
                filterContent.stop().slideToggle(300);
            }
        });

        $('.auction-lots-filter--extra .close').on('click',function(){
            if($('.filter-btn').hasClass('active')){
                filterContent.slideUp(300);
                $('.filter-btn').removeClass('active');
            } else {
                $('.filter-btn').addClass('active');
                filterContent.slideDown(300);
            }
        });
    },

    initFilteringFilterSettingsSelects() {
        let multipleOptions = {
            placeholder: 'Select',
            closeOnSelect : false,
            allowClear: true,
        };

        $('.settings-multi').select2(multipleOptions);

        let selectAllSelect = $('.select-all');
        selectAllSelect.on('select2:select', function () {
            let thisSelect = $(this);
            if (thisSelect.val().includes('Select all')) {
                thisSelect.select2('destroy').find('option').prop('selected', 'selected').end().select2(multipleOptions);
            }
        });

        selectAllSelect.on('select2:unselect', function (e) {
            if (e.params.data.text === 'Select all') {
                $(this).val(null).trigger('change');
            }
        });


    },

    filteringClearAllFilters() {
        $('.clear-all-filters').on('click', function (e) {
            e.preventDefault();

            $('.auction-filter--settings-row select').each(function (i, val) {
                $(val).val(null).trigger('change');
            });

            $('.filter-added-items').empty();
        });
    },

    auctionFavorite(){
        $('.product-card--favorite').on('click',function(){
            $(this).toggleClass('active');
        })
    },

    filterButton(){
        // $('.auction-lots--filter-item').on('click',function(){
        //     let loader = $('.loader-holder');
        //     loader.show();
        //     $('.auction-lots--filter-item').removeClass('active');
        //     $(this).addClass('active');
        //     setTimeout(function () {
        //         loader.fadeOut(300);
        //     }, 5000);
        // })
    },
}